export default __webpack_public_path__ + "9e3d227b5ae2d495d7c2f3b7a154b7b1.png";